import { AxiosError } from 'axios';
import { KeyedMutator } from 'swr/dist';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { CardTransaction } from '../../domain/Card/entities/CardTransaction';
import { CardTransactionDetails } from '../../domain/Card/entities/CardTransaction';
import {
  CardIdentifier,
  CardListPagination,
  CardTransactionsResponseBody,
  PaymentCardIdentification,
} from '../../types';
import { CardDetails } from '../../domain/Card/entities/CardDetails';
import { Card } from '../../domain/Card/entities/Card';
import { CardAction } from '../CardActions';

export interface CardDetailsProviderProps {
  cardListData?: Nullable<Card[]>;
  shouldNotFetchCardTransactions?: boolean;
}

export interface CardDetailsState {
  cardDetailsData?: Nullable<CardDetails>;
  cardTransactionsData?: Nullable<CardTransaction[]>;
  selectedCardTransaction: Nullable<CardTransaction>;
  selectedCard: Nullable<{
    card: Nullable<Card | CardDetails>;
    timestamp: string;
  }>;
  selectedPaymentCardIdentifications: Nullable<PaymentCardIdentification[]>;
  selectedCardAction: Nullable<{ action: CardAction; timestamp: string }>;
  cardTransactionDetailsData?: Nullable<CardTransactionDetails>;
  cardTransactionsFilters: Partial<CardTransactionListFilters & { timestamp?: string }>;
  cardTransactionsPagination: Partial<CardListPagination>;
  errorState: {
    cardTransactionsDataError?: AxiosError<APIGatewayResponse<any>, any>;
    cardDetailsDataError?: AxiosError<APIGatewayResponse<any>, any>;
  };
  loadingState: {
    isLoadingCardTransactionsData: boolean;
    isLoadingCardDetailsData: boolean;
  };
  onSetSelectedCard: (card: Nullable<Card>, cardAction: Nullable<CardAction>) => void;
  onCardTransactionSelect: (transactionNo: string) => void;
  onCardTransactionListFiltersChange: (filters: CardTransactionListFilters) => void;
  refetchCardsDetailsDataMutation?: KeyedMutator<CardDetails>;
  refetchCardsTransactionsDataMutation?: KeyedMutator<CardTransactionsResponseBody>;
}

export type CardSize = 'sm' | 'md' | 'lg';

export enum CardDetailsContextActionTypes {
  SetSelectedCard = '@@/Cards/SET_SELECTED_CARD',
  SetSelectedPaymentCardIdentifications = '@@/Cards/SET_SELECTED_PAYMENT_CARD_IDENTIFICATIONS',
  SetSelectedCardAction = '@@/Cards/SET_SELECTED_CARD_ACTION',
  SetCardTransactionsFilters = '@@/Cards/SET_TRANSACTIONS_FILTERS',
  SetSelectedCardTransaction = '@@/Cards/SET_SELECTED_CARD_TRANSACTION',
}

export type CardTransactionListFilters = {
  dateFrom: string;
  dateTo: string;
  pageNumber: number;
  pageSize: number;
  amountFrom?: number;
  amountTo?: number;
  status?: string;
  merchant?: string;
  transactionIdentification?: {
    transactionIdentificationType: string;
    identifier: CardIdentifier;
  };
};
